module.exports = __webpack_public_path__ + "img/santa.6d8ccb75.svg";